define(["require", "exports", "hypo_elements/Typescripts/Configuration/Configuration", "jquery", "jquery-waypoints"], function (require, exports, Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var inhaltsverzeichnisContainerClass = "inhaltsverzeichnis_container";
    var inhaltsverzeichnisHeadClass = "inhaltsverzeichnis_head";
    var inhaltsverzeichnisHeadSelector = "." + inhaltsverzeichnisHeadClass;
    var inhaltsverzeichnisBodyClass = "inhaltsverzeichnis_body";
    var inhaltsverzeichnisBodySelector = "." + inhaltsverzeichnisBodyClass;
    var isOpenState = "--is-open";
    var inhaltsverzeichnisContainerIsOpenClass = inhaltsverzeichnisContainerClass + isOpenState;
    var inhaltsverzeichnisHeadIsOpenClass = inhaltsverzeichnisHeadClass + isOpenState;
    var inhaltsverzeichnisHeadIsOpenSelector = inhaltsverzeichnisHeadSelector + isOpenState;
    var headerClass = "header";
    var headerStickyClass = "header--is-sticky'";
    var paddingTop = 16;
    var $bodySection;
    var $header;
    var $headerInhaltsverzeichnis;
    var $inhaltsverzeichnis;
    var $inhaltsverzeichnisContainer;
    var $inhaltsverzeichnisContainerSticky;
    var $inhaltsverzeichnisContent;
    var $inhaltsverzeichnisOuterHeight;
    var $inhaltsverzeichnisHead;
    var $inhaltsverzeichnisBody;
    var $inhaltsverzeichnisList;
    var $inhaltsverzeichnisLinks;
    var $inhaltsverzeichnisStickyLinks;
    var $inhaltsverzeichnisWaypoints = false;
    var $ariaOpen;
    var $ariaClose;
    $(function () {
        $bodySection = $("body > section");
        $header = $(headerClass);
        $headerInhaltsverzeichnis = $header.find(".header_inhaltsverzeichnis");
        $inhaltsverzeichnis = $("#inhaltsverzeichnis");
        $inhaltsverzeichnisOuterHeight = $inhaltsverzeichnis.outerHeight();
        $inhaltsverzeichnisContainer = $(".inhaltsverzeichnis_container:not(.sticky)");
        $inhaltsverzeichnisContainerSticky = $(".inhaltsverzeichnis_container.sticky");
        $inhaltsverzeichnisContainerSticky.appendTo($headerInhaltsverzeichnis);
        $inhaltsverzeichnisContent = $(".inhaltsverzeichnis_content");
        $inhaltsverzeichnisHead = $(inhaltsverzeichnisHeadSelector);
        $inhaltsverzeichnisBody = $(inhaltsverzeichnisBodySelector);
        var ariaSelect = $inhaltsverzeichnisBody.attr('data-initial') || '';
        $ariaOpen = $inhaltsverzeichnisHead.attr('aria-label') || '';
        $ariaClose = $inhaltsverzeichnisHead.attr('data-revert') || '';
        if (ariaSelect === '0') {
            $ariaClose = $inhaltsverzeichnisHead.attr('aria-label') || '';
            $ariaOpen = $inhaltsverzeichnisHead.attr('data-revert') || '';
        }
        $inhaltsverzeichnisList = $inhaltsverzeichnis.find(".inhaltsverzeichnis_list li");
        $inhaltsverzeichnisLinks = $inhaltsverzeichnis.find(".inhaltsverzeichnis_list li a");
        $inhaltsverzeichnisLinks.each(function (index, element) {
            var $element = $(element);
            var href = $element.attr("href");
            if (href) {
                $element.on("click", function (e) {
                    e.preventDefault();
                    var elementOffset = $(href).offset();
                    $("html, body").animate({
                        scrollTop: elementOffset.top - (Configuration_1.configuration.stickyHeaderHeight + 24),
                    }, Configuration_1.configuration.scrollToHeadingAnimationTimeInMs, function () {
                        checkInhaltsverzeichnis();
                    });
                });
            }
        });
        initInhaltsverzeichnis();
        checkInhaltsverzeichnis();
        $(window).on("scroll", function () {
            checkInhaltsverzeichnis();
        });
    });
    function checkInhaltsverzeichnis() {
        var elementTop = $inhaltsverzeichnis.offset().top;
        var elementBottom = elementTop + $inhaltsverzeichnisOuterHeight;
        var viewportTop = $(window).scrollTop() || 0;
        if ((elementBottom - 80) < (viewportTop + Configuration_1.configuration.stickyHeaderHeight)) {
            if (!($inhaltsverzeichnis.hasClass("is-sticky"))) {
                $inhaltsverzeichnis.css("height", $inhaltsverzeichnisOuterHeight - 24);
                $inhaltsverzeichnisContent.prependTo($inhaltsverzeichnisContainerSticky);
                $headerInhaltsverzeichnis.animate({ opacity: 1 }, Configuration_1.configuration.klappmodulOpenCloseAnimationTimeInMs);
                $inhaltsverzeichnisContainerSticky.animate({ opacity: 1 }, Configuration_1.configuration.klappmodulOpenCloseAnimationTimeInMs);
                if ($inhaltsverzeichnisContainerSticky.hasClass("sticky--closed")) {
                    $inhaltsverzeichnisBody.hide();
                    $inhaltsverzeichnisContainer.removeClass(inhaltsverzeichnisContainerIsOpenClass);
                    $inhaltsverzeichnisHead.removeClass(inhaltsverzeichnisHeadIsOpenClass).attr('aria-label', $ariaOpen);
                }
                $inhaltsverzeichnis.addClass("is-sticky");
                $headerInhaltsverzeichnis.css('display', 'block');
                $inhaltsverzeichnisStickyLinks = $inhaltsverzeichnisContainerSticky.find(".inhaltsverzeichnis_list li a");
                $inhaltsverzeichnisStickyLinks.on("click", function () {
                    toggleInhaltsverzeichnis();
                });
                setWaypoints();
            }
        }
        else {
            if (($inhaltsverzeichnis.hasClass("is-sticky"))) {
                $inhaltsverzeichnisContent.appendTo($inhaltsverzeichnisContainer);
                if ($inhaltsverzeichnisContainer.hasClass("initial--open")) {
                    $inhaltsverzeichnisBody.show();
                    $inhaltsverzeichnisContainer.addClass(inhaltsverzeichnisContainerIsOpenClass);
                    $inhaltsverzeichnisHead.addClass(inhaltsverzeichnisHeadIsOpenClass).attr('aria-label', $ariaClose);
                }
                $inhaltsverzeichnis.removeClass("is-sticky").css("width", "auto");
                $headerInhaltsverzeichnis.css('display', 'none');
                $inhaltsverzeichnisStickyLinks = $inhaltsverzeichnisContainerSticky.find(".inhaltsverzeichnis_list li a");
                $inhaltsverzeichnisStickyLinks.unbind('click');
                $inhaltsverzeichnis.css("height", "auto");
                $headerInhaltsverzeichnis.css("opacity", 0);
                $inhaltsverzeichnisContainerSticky.css("opacity", 0);
                $inhaltsverzeichnisList.removeClass("active");
            }
        }
    }
    function setWaypoints() {
        if ($inhaltsverzeichnisWaypoints) {
            Waypoint.refreshAll();
        }
        else {
            $("h1,h2,h3,h4,div.heading").filter("[data-sprungliste=true]").each(function (index, element) {
                $(element).waypoint(function (direction) {
                    if (direction === "down") {
                        $inhaltsverzeichnisList.removeClass("active");
                        $inhaltsverzeichnisList.filter("[data-element-id=\"" + this.element.id + "\"]").addClass("active");
                    }
                }, {
                    offset: Configuration_1.configuration.stickyHeaderHeight + "px",
                });
                $(element).waypoint(function (direction) {
                    if (direction === "up") {
                        $inhaltsverzeichnisList.removeClass("active");
                        $inhaltsverzeichnisList.filter("[data-element-id=\"" + this.element.id + "\"]").addClass("active");
                    }
                }, {
                    offset: "0",
                });
            });
            $inhaltsverzeichnisWaypoints = true;
        }
    }
    function initInhaltsverzeichnis() {
        if ($header.hasClass(headerStickyClass)) {
            $headerInhaltsverzeichnis.css('display', 'block');
        }
        else {
            $headerInhaltsverzeichnis.css('display', 'none');
        }
        $inhaltsverzeichnisHead.not(inhaltsverzeichnisHeadIsOpenSelector).siblings(inhaltsverzeichnisBodySelector).hide();
        $inhaltsverzeichnisHead.off("click").click(function () {
            toggleInhaltsverzeichnis();
        });
    }
    function toggleInhaltsverzeichnis() {
        $inhaltsverzeichnisBody
            .stop()
            .slideToggle(Configuration_1.configuration.klappmodulOpenCloseAnimationTimeInMs, function () {
            if ($inhaltsverzeichnisHead.hasClass(inhaltsverzeichnisHeadIsOpenClass) && !completeElementIsVisible($inhaltsverzeichnis)) {
                scrollContentIntoView($inhaltsverzeichnis);
            }
        });
        $inhaltsverzeichnisContainer.toggleClass(inhaltsverzeichnisContainerIsOpenClass);
        $inhaltsverzeichnisHead.toggleClass(inhaltsverzeichnisHeadIsOpenClass);
        if ($inhaltsverzeichnisHead.hasClass(inhaltsverzeichnisHeadIsOpenClass)) {
            $inhaltsverzeichnisHead.attr('aria-label', $ariaOpen);
        }
        else {
            $inhaltsverzeichnisHead.attr('aria-label', $ariaClose);
        }
        if ($inhaltsverzeichnis.hasClass("is-sticky")) {
            $bodySection.off(".closeivz");
            if ($inhaltsverzeichnisHead.hasClass(inhaltsverzeichnisHeadIsOpenClass)) {
                $bodySection.on("click.closeivz", function (event) {
                    toggleInhaltsverzeichnis();
                });
            }
        }
    }
    function completeElementIsVisible($element) {
        var elementOffsetTop = $element.offset().top - $(window).scrollTop();
        return elementOffsetTop + $element.height() < window.innerHeight;
    }
    function scrollContentIntoView($element) {
        var distanceToWindowBorder = 50;
        var offset;
        if (window.innerHeight > $element.height()) {
            offset = window.innerHeight - $element.height() - distanceToWindowBorder;
        }
        else {
            offset = distanceToWindowBorder;
        }
        $("html, body").animate({
            scrollTop: $element.offset().top - offset,
        });
    }
});
